// ═══════════════════════════════════════════════════════════════
// ClearView CRM Supabase Client
// ═══════════════════════════════════════════════════════════════
import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://zuujknqxwdtfsjinzbxd.supabase.co";
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp1dWprbnF4d2R0ZnNqaW56YnhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI0NzI2OTksImV4cCI6MjA4ODA0ODY5OX0.K4IShjlE4_bIENxyIQlYSLxvymN4cn71KzW95QQtXnM";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
